import * as React from "react";

function RotateRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M496 72v128c0 13.3-10.7 24-24 24H344c-13.19 0-24-10.66-24-23.98 0-6.247 2.432-12.39 7.033-16.99L379.2 130.9C346.9 99.29 303.1 80 256 80c-97.9 0-176 78.1-176 176s78.97 176 176 176c81.21 0 107.1-46.34 127.1-46.34 10.18 0 24.02 8.003 24.02 24.01 0 25.11-75.1 70.27-152.1 70.27-123.5 0-223.9-100.4-223.9-223.9s100.4-223.1 223.9-223.1c60.03 0 116 24.58 157.1 64.95l41.1-41.1c4.601-4.601 10.74-7.019 16.99-7.019C485.4 48.01 496 58.83 496 72z"
  }));
}

const ForwardRef = React.forwardRef(RotateRightIcon);
export default ForwardRef;